module.exports = __webpack_public_path__ + "images/b3ba2cd93d974a1300caadd653fbc843.svg";